import { auth } from '@/services/auth'

const authenticate = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    auth.authenticate(payload).then(() => {
      commit('IS_AUTHENTICATED', { isAuthenticated: auth.isAuthenticated() })
      if (auth.isAuthenticated()) {
        let roles = auth.getRoles(payload.googleUser.getBasicProfile().getEmail())
        commit('SET_ROLES', roles)
        resolve()
      } else {
        reject(new Error('Not authorized'))
      }
    })
      .catch((error) => {
        reject(error)
      })
  })
}

const authorize = ({commit}) => {
  return new Promise((resolve, reject) => {
    commit('IS_AUTHENTICATED', { isAuthenticated: auth.isAuthenticated() })
    if (auth.isAuthenticated()) {
      resolve()
    } else {
      reject(new Error('Not authorized'))
    }
  })
}

const logout = ({commit}) => {
  return new Promise((resolve, reject) => {
    auth.logout()
    commit('IS_AUTHENTICATED', { isAuthenticated: auth.isAuthenticated() })
    resolve()
  })
}

export default {
  authenticate,
  authorize,
  logout
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js